export default __webpack_public_path__ + "static/media/lyte-chocolate-bar.1f864ed8.png";